export default __webpack_public_path__ + "static/media/17.c8ae7fb8.webp";